// @flow strict
const PAGINATION = {
  PREV_PAGE: '← Anterior',
  NEXT_PAGE: '→ Siguiente'
};

export default PAGINATION;
